import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../../app.constants';
import { OidcSecurityService } from '../../../auth/services/oidc.security.service';
import { ActivitySearchModel } from '../../models/activity-related/ActivitySearchModel';
import { ActivityUpdateModel } from '../../models/activity-related/ActivityUpdateModel';
import { ActivityCreateModel } from '../../models/activity-related/ActivityCreateModel';

@Injectable()
export class ActivityWidgetService {

    private actionUrl: string;
    private headers: Headers;
    private uData: any;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
        this.actionUrl = `${_configuration.Server}api/ActivityWidget/`;
        this._securityService.getUserData().subscribe(data => this.uData = data);
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    public Get = (id: number): Observable<ActivitySearchModel> => {
        this.setHeaders();
        let params: URLSearchParams = new URLSearchParams();
        params.set('id', id.toString());

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public Update = (id: number, activity: string): Observable<Response> => {
        this.setHeaders();
        let updatedActivity: ActivityUpdateModel = {
            Id: id,
            Activity: activity
        }

        let options = new RequestOptions({ headers: this.headers });
        return this._http.put(this.actionUrl, JSON.stringify(updatedActivity), options).map(res => res.json());
    }

    public Create = (newActivity: ActivityCreateModel): Observable<Response> => {
        this.setHeaders();

        let options = new RequestOptions({ headers: this.headers });
        return this._http.post(this.actionUrl, JSON.stringify(newActivity), options).map(res => res.json());
    }

    public Delete = (id: number): Observable<Response> => {
        this.setHeaders();

        let options = new RequestOptions({ headers: this.headers });
        return this._http.delete(this.actionUrl + id, options).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/activity-widget-container/activity-widget/activity-widget.service.ts